// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2PM8u","search":"Settings_search__2vOFT","filter":"Settings_filter__2hn0V"};